/**
 * Internal dependencies
 */

import WMUWCPopinManager from "./manager";


const manager = new WMUWCPopinManager( {
	defaultTemplateId: wmuwcPopinArgs.defaultTemplateId
} );
export {
	manager
};